"use client";
import { AutocompleteInput } from "@/components/search/autocomplete-input";
import { useTalentSearchFilters } from "@/components/search/talent-search-filters-provider";
import type { AutocompleteResult, VariantFilterValue } from "@/lib/api/types";
import { hasEntityForm } from "@/lib/search/entity-variants";
import { ScopedListHeader, ScopedValueList } from "./scoped-list";

export function FilterIndustrySection() {
  const { filters, updateFilter } = useTalentSearchFilters();
  const industries = filters.industries ?? [];
  const fallbackScope = filters.industry_filter_type ?? "cp";

  const add = (item: VariantFilterValue) => {
    if (hasEntityForm(industries, item.text ?? "")) return;
    updateFilter("industries", [...industries, item]);
  };

  return (
    <>
      <div className="flex flex-col gap-1 w-full">
        <ScopedListHeader
          label="Industries"
          items={industries}
          fallbackScope={fallbackScope}
          onChange={(next) => updateFilter("industries", next)}
        />
        <AutocompleteInput
          variant="filter"
          field="industries"
          placeholder="Search..."
          showAllOnOpen
          onSelect={(result: AutocompleteResult) => {
            add({ canonical_id: result.canonical_id ?? undefined, text: result.value, required: false, scope: "cp" });
          }}
          onFreeText={(text: string) => {
            add({ text: text.toLowerCase(), required: false, scope: "cp" });
          }}
        />
      </div>
      <ScopedValueList
        items={industries}
        fallbackScope={fallbackScope}
        variantsField="industries"
        onChange={(next) => updateFilter("industries", next)}
      />
    </>
  );
}
